import { Injectable } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs/operators'

/**
 * Tracks completed in-app navigations so callers can decide whether
 * `Location.back()` will land on something useful.
 *
 * `window.history.length` is unreliable here: it counts pre-app entries
 * (Auth0 redirects, the tab's prior URLs) so on a deep link it can be > 1
 * even though there is no in-app history to walk — calling history.back()
 * then bounces the user through a redirect chain that lands them right
 * back on the current page.
 */
@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
    private _navigationCount = 0

    constructor(router: Router) {
        router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe(() => this._navigationCount += 1)
    }

    /** True once the user has navigated at least once after the initial load. */
    canGoBack(): boolean {
        return this._navigationCount >= 2
    }
}
